import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import authService from '../../services/AuthService';
import api, { apiResponseHandler, apiErrorHandler } from '../../services/AxiosService';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class MetricsAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            totalAssessments: 0,
            totalClinicianAssessments: 0,
            totalParentAssessments: 0,
            avgPatientsPerClinician: 0,
            avgChildrenPerParent: 0,
            avgAssessmentsPerPatient: 0,
            avgAssessmentsPerChild: 0,
            totalReports: 0,
            totalClinicianReports: 0,
            totalParentReports: 0,
            clinicianAssessmentReporting: 0,
            parentAssessmentReporting: 0
        }

        this.itemDefs = [];
    }

    componentDidMount = () => {
        /*
         * Run a query to get the item information for the domain specified in props (null is all domains).
         * The query returns a list of definitions. 
         */
        let domainName = (this.state.domain == null || this.state.domain == "") ? "All" : this.state.domain;

        let url = "admin/usagemetrics";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                this.setState({
                    totalAssessments: response.data.totalAssessments,
                    totalClinicianAssessments: response.data.totalClinicianAssessments,
                    totalParentAssessments: response.data.totalParentAssessments,
                    avgPatientsPerClinician: response.data.avgPatientsPerClinician,
                    avgChildrenPerParent: response.data.avgChildrenPerParent,
                    avgAssessmentsPerPatient: response.data.avgAssessmentsPerPatient,
                    avgAssessmentsPerChild: response.data.avgAssessmentsPerChild,
                    totalReports: response.data.totalReports,
                    totalClinicianReports: response.data.totalClinicianReports,
                    totalParentReports: response.data.totalParentReports,
                    clinicianAssessmentReporting: response.data.clinicianAssessmentReporting,
                    parentAssessmentReporting: response.data.parentAssessmentReporting
                });
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login?
            this.setState({ showErrorAlert: true });
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        const col1Width = 8;
        const col2Width = 4;
        return (

            <Fragment>
                <h4>Usage Summary</h4>
                <Container fluid>
                    <Row>
                        <Col sm={3}>
                            <h4 className="metrics_heading">Assessments</h4>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Total Assessments</Col>
                                <Col sm={col2Width}>{this.state.totalAssessments}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent1">Clinicians</Col>
                                <Col sm={col2Width}>{this.state.totalClinicianAssessments}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent1">Parents</Col>
                                <Col sm={col2Width}>{this.state.totalParentAssessments}</Col>
                            </Row>
                        </Col>
                        <Col sm={3}>
                            <h4 className="metrics_heading">Children Per Account</h4>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Patients per Clinician</Col>
                                <Col sm={col2Width}>{this.state.avgPatientsPerClinician}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Children per Parent</Col>
                                <Col sm={col2Width}>{this.state.avgChildrenPerParent}</Col>
                            </Row>
                        </Col>
                        <Col sm={3}>
                            <h4 className="metrics_heading">Assessments Per Child</h4>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Avg Patient Assessments</Col>
                                <Col sm={col2Width}>{this.state.avgAssessmentsPerPatient}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Avg Child Assessments</Col>
                                <Col sm={col2Width}>{this.state.avgAssessmentsPerChild}</Col>
                            </Row>
                        </Col>
                        <Col sm={3}>
                            <h4 className="metrics_heading">Reports Per Account</h4>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Total Reports</Col>
                                <Col sm={col2Width}>{this.state.totalReports}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent1">Clinicians</Col>
                                <Col sm={col2Width}>{this.state.totalClinicianReports}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent2">Assessments with Reports</Col>
                                <Col sm={col2Width}>{this.state.clinicianAssessmentReporting}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent1">Parents</Col>
                                <Col sm={col2Width}>{this.state.totalParentReports}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent2">Assessments with Reports</Col>
                                <Col sm={col2Width}>{this.state.parentAssessmentReporting}</Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default MetricsAccount;


// WEBPACK FOOTER //
// ./src/components/AdminHome/metricsUsage.js